import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clear-vacant-property',
  templateUrl: './clear-vacant-property.component.html',
  styleUrls: ['./clear-vacant-property.component.css']
})
export class ClearVacantPropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/clear-vacant-property/clear-vacant-property.component.ts